import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage/storage.service';
import { APP_ROUTES } from '../../app.routes.model';

export const isNotAuthenticatedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);
  const isAuthenticated = inject(StorageService).getAuthToken();
  const returnUrl =
    route.data['returnUrl'] && route.data['returnUrl'](route.queryParamMap);

  if (!isAuthenticated) {
    return true;
  }

  if (returnUrl) {
    return router.navigateByUrl(returnUrl);
  }

  return router.navigate([APP_ROUTES.home]);
};
